"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleAdapter = void 0;
exports.ConsoleAdapter = {
    format: function (level, _context) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return {
            payload: args !== null && args !== void 0 ? args : null,
            level: level,
            timestamp: new Date(),
        };
    },
    output: function (level, context, message) {
        var label = context.label;
        var output = __assign({ $context: label !== null && label !== void 0 ? label : null }, message);
        if (level === "fatal") {
            console.error(output);
            return;
        }
        console[level](output);
    },
};
//# sourceMappingURL=consoleAdapter.js.map